import { render, staticRenderFns } from "./OrderPreview.vue?vue&type=template&id=26522af4&"
import script from "./OrderPreview.vue?vue&type=script&lang=js&"
export * from "./OrderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports